module.exports = __webpack_public_path__ + "img/plante.800b57c1.png";